/**
 * Recorded DOM is untrusted, even when an upload credential is valid.
 * rrweb's unsafe canvas mode adds allow-scripts to its same-origin iframe.
 * Keep scripts disabled: parent-driven DOM replay still works, but dynamic
 * canvas command replay is intentionally unavailable.
 */
export const REPLAY_SECURITY_OPTIONS = Object.freeze({
  UNSAFE_replayCanvas: false,
});
